<template>
  <div class="flex flex-col">
    <div class="mb-4">
      <label class="block text-gray-700 text-sm font-bold mb-2">Formato</label>
      <Treeselect
        :options="[
          { id: 'vertical', label: 'Vertical' },
          { id: 'horizontal', label: 'Horizontal' },
        ]"
        :clearable="false"
        v-model="format"
      />
    </div>
    <div v-if="format === 'horizontal'" class="mb-4">
      <label class="block text-gray-700 text-sm font-bold mb-2"
        >Lado del logo</label
      >
      <Treeselect
        :options="[
          { id: 'left', label: 'Izquierda' },
          { id: 'right', label: 'Derecha' },
        ]"
        :clearable="false"
        v-model="logoSide"
      />
    </div>
    <div class="mb-4">
      <label for="" class="block text-gray-700 text-sm font-bold mb-2"
        >Primera línea</label
      >
      <Treeselect :multiple="true" :options="options" v-model="firstLine" />
    </div>
    <div class="mb-4">
      <label for="" class="block text-gray-700 text-sm font-bold mb-2"
        >Segunda línea</label
      >
      <Treeselect :multiple="true" :options="options" v-model="secondLine" />
    </div>
    <div class="mb-4">
      <label for="" class="block text-gray-700 text-sm font-bold mb-2"
        >Tercera línea</label
      >
      <Treeselect :multiple="true" :options="options" v-model="thirdLine" />
    </div>
    <div class="flex items-center justify-end pt-4 border-t">
      <button
        :disabled="loading"
        @click="submit"
        class="py-2 px-4 border border-gray-600 hover:bg-indigo-600 hover:text-white hover:border-transparent rounded focus:outline-none flex"
      >
        {{ stateText }}
        <svg
          v-if="loading"
          class="animate-spin -mr-1 ml-3 h-5 w-5"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            class="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="4"
          ></circle>
          <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import { jsPDF } from "jspdf";
import { mapActions, mapState } from "vuex";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

import { slugify } from "@/utils";

export default {
  components: {
    Treeselect,
  },
  props: {
    entries: {
      type: Array,
      required: true,
    },
    student: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    const options =
      this.student === true
        ? [
            {
              id: "ID_Location",
              label: "ID Localización",
            },
            { id: "ID_Curso", label: "ID Curso" },
            { id: "ID_Alumno", label: "ID Alumno" },
            { id: "nombre", label: "Nombre" },
            { id: "apellidos", label: "Apellidos" },
            { id: "grupo", label: "Grupo" },
            { id: "descripcion", label: "Descripción Curso" },
          ]
        : [
            { id: "ID_Location", label: "ID Localización" },
            { id: "ID_Instructor", label: "ID Instructor" },
            { id: "nombre", label: "Nombre" },
            { id: "apellidos", label: "Apellidos" },
          ];

    return {
      options,
      format: "vertical",
      logoSide: "left",
      image: "",
      loading: false,
      firstLine: this.student ? ["ID_Alumno"] : ["ID_Instructor"],
      secondLine: ["nombre"],
      thirdLine: ["apellidos"],
      cellWidth: 65,
      lineLenght: 5,
      pageColumns: 3,
      paddingLeft: 7.5,
    };
  },
  computed: {
    ...mapState(["user"]),
    maxImageHeight() {
      switch (this.format) {
        case "vertical":
          return 20;
        case "horizontal":
          return 15;
        default:
          return 0;
      }
    },
    cellHeight() {
      switch (this.format) {
        case "vertical":
          return 65;
        case "horizontal":
          return 22;
        default:
          return 0;
      }
    },
    paddingTop() {
      switch (this.format) {
        case "vertical":
          return 18.5;
        case "horizontal":
          return 5.5;
        default:
          return 0;
      }
    },
    pageRows() {
      switch (this.format) {
        case "vertical":
          return 4;
        case "horizontal":
          return 13;
        default:
          return 0;
      }
    },
    stateText() {
      return this.loading ? "Procesando" : "Generar";
    },
  },
  methods: {
    ...mapActions(["getData"]),
    submit() {
      if (this.image === null || this.image === "") {
        window.alert("Debes configurar el logo del centro.");
        return;
      }

      this.loading = true;

      const doc = new jsPDF();
      doc.setDrawColor(0, 0, 0);

      const imageProperties = doc.getImageProperties(this.image);
      const imageWidth = imageProperties.width * 0.26; // mm
      const imageHeight = imageProperties.height * 0.26; // mm
      const ratio = imageWidth / imageHeight;

      const finalImageHeight =
        imageHeight > this.maxImageHeight ? this.maxImageHeight : imageHeight;
      const finalImageWidth = finalImageHeight * ratio;

      if (this.entries.length === 0) {
        console.log("No entries");
        return;
      }

      const cells = this.pageRows * this.pageColumns;
      const pages =
        this.entries.length / cells <= 1
          ? 1
          : Math.ceil(this.entries.length / cells);

      for (let i = 0; i < pages; i += 1) {
        // skip first page
        if (i !== 0) {
          doc.addPage();
        }

        for (
          let row = 0, y = this.paddingTop;
          row < this.pageRows;
          row += 1, y += this.cellHeight
        ) {
          for (
            let column = 0, x = this.paddingLeft;
            column < this.pageColumns;
            column += 1, x += this.cellWidth
          ) {
            // top left
            doc.line(x, y, x + this.lineLenght, y);
            doc.line(x, y, x, y + this.lineLenght);

            //top right
            doc.line(
              x + this.cellWidth - this.lineLenght,
              y,
              x + this.cellWidth,
              y
            );
            doc.line(
              x + this.cellWidth,
              y,
              x + this.cellWidth,
              y + this.lineLenght
            );

            // botttom left
            doc.line(
              x,
              y + this.cellHeight,
              x + this.lineLenght,
              y + this.cellHeight
            );
            doc.line(
              x,
              y + this.cellHeight - this.lineLenght,
              x,
              y + this.cellHeight
            );

            // bottom right
            doc.line(
              x + this.cellWidth - this.lineLenght,
              y + this.cellHeight,
              x + this.cellWidth,
              y + this.cellHeight
            );
            doc.line(
              x + this.cellWidth,
              y + this.cellHeight - this.lineLenght,
              x + this.cellWidth,
              y + this.cellHeight
            );

            const index = i * cells + this.pageColumns * row + column;
            if (typeof this.entries[index] === "undefined") {
              continue;
            }

            // image
            const imageX =
              this.format === "vertical"
                ? x + this.cellWidth / 2 - finalImageWidth / 2
                : x +
                  (this.logoSide === "left"
                    ? 2.5
                    : this.cellWidth - finalImageWidth - 2.5);
            const imageY =
              y +
              this.cellHeight / 2 -
              finalImageHeight / 2 -
              (this.format === "vertical" ? 10 : 0);
            doc.addImage(
              this.image,
              "JPEG",
              imageX,
              imageY,
              finalImageWidth,
              finalImageHeight
            );

            // first line
            const firstLine = doc
              .setFontSize(12)
              .splitTextToSize(
                this.firstLine
                  .map((field) => this.entries[index][field])
                  .join(" "),
                50
              )
              .map((line) => {
                return line.replace(/\s+/g, " ").trim();
              });
            const firstLineX =
              x +
              this.cellWidth / 2 +
              (this.format === "vertical"
                ? 0
                : 7.5 * (this.logoSide === "left" ? 1 : -1));
            const firstLineY =
              y +
              this.cellHeight / 2 +
              (this.format === "vertical"
                ? firstLine.length === 1
                  ? 7.5
                  : 5
                : -2.5);
            doc.text(firstLine, firstLineX, firstLineY, { align: "center" });

            // second line
            const secondLine = doc
              .setFontSize(this.format === "vertical" ? 10 : 8)
              .splitTextToSize(
                this.secondLine
                  .map((field) => this.entries[index][field])
                  .join(" "),
                50
              )
              .map((line) => {
                return line.replace(/\s+/g, " ").trim();
              });
            const secondLineY =
              y + this.cellHeight / 2 + (this.format === "vertical" ? 15 : 2.5);
            doc.text(secondLine, firstLineX, secondLineY, { align: "center" });

            // third line
            const thirdLine = doc
              .setFontSize(8)
              .splitTextToSize(
                this.thirdLine
                  .map((field) => this.entries[index][field])
                  .join(" "),
                50
              )
              .map((line) => {
                return line.replace(/\s+/g, " ").trim();
              });
            doc.text(thirdLine, firstLineX, secondLineY + 5, {
              align: "center",
            });
          }
        }
      }

      const link = document.createElement("a");

      const blob = new Blob([doc.output("blob")], { type: "application/pdf" });

      link.href = URL.createObjectURL(blob);
      const fileName = slugify(this.user.colegio_title);
      link.download = `stickers-${fileName}.pdf`;

      link.click();

      URL.revokeObjectURL(link.href);

      this.loading = false;
    },
  },
  async created() {
    const group = await this.getData("getGroup");

    this.image = group.logo;
  },
};
</script>
